var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Spin',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSpinShow),expression:"isSpinShow"}],attrs:{"fix":"","size":"large"}}),_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.wechatScan}},[_vm._v("扫描")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }